import React from 'react';
import { Dropdown, Label, Validation, ValidationStatus } from '@silverfort/sf-components';

interface Props<T> {
    label: string;
    placeholder?: string;
    listOptions: { title: string; value: T; disabled: boolean; subtitle: string }[];
    value?: T;
    onChange: (val: T) => void;
    isDisabled: boolean;
    errorMessage?: string;
}

const TokenDropdown = <T,>({
    label,
    placeholder,
    listOptions,
    value,
    onChange,
    isDisabled,
    errorMessage
}: Props<T>) => (
    <div className="flex flex-row flex-1 flex-start items-center flex-grow-0 gap-2">
        <Label text={label} mandatory className="w-[245px]" />
        <div className="flex flex-col h-10">
            <Dropdown
                className="min-h-10 max-h-10"
                variant="trigger"
                text={placeholder}
                items={listOptions}
                selectedItems={value}
                // @ts-ignore: The onChange handler in the Dropdown component provides a parameter of type T | T[] | undefined, which is not compatible with the expected type TokenKey.
                // Ticket: https://silverfort.atlassian.net/browse/AF-35919
                onChange={onChange}
                disabled={isDisabled}
            />
            {errorMessage && (
                <Validation showIcon={false} text={errorMessage} validationStatus={ValidationStatus.Error} />
            )}
        </div>
    </div>
);

export default TokenDropdown;
